export enum ChatChannelType {
    Accel = 'accel',
    Max = 'max',
    Vk = 'vk',
    Tg = 'tg',
    Vb = 'vb',
    Fb = 'fb',
    Wazzup24 = 'wazzup24',
    Wa = 'wa',
    Ig = 'ig',
    Line = 'line',
    SMSC = 'smsc',
    Twilio = 'twilio',
    RingCentral = 'ringCentral',
    Liza = 'liza',
}
